import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ContentListLayer from "../components/ContentListLayer";

const ContentManagementPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Page Content Management' />

        {/* BlogLayer */}
        <ContentListLayer />
      </MasterLayout>
    </>
  );
};

export default ContentManagementPage;